import styled from 'styled-components';
export const StyledInput = styled.input `
  ${({ theme }) => theme.typography.textMedium}
  width: ${({ width }) => width || '100%'};
  height: 36px;
  padding: 8px ${({ withIcon }) => (withIcon ? '36px' : '12px')} 8px 12px;
  border: none;
  color: ${({ theme }) => theme.colors.black_1};
  z-index: 2;
  background-color: transparent;
  min-width: ${({ minWidth }) => minWidth && `${minWidth}px`};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey70_1} !important;
  }

  &[disabled] {
    color: ${({ theme }) => theme.colors.grey100_2};
    cursor: not-allowed;

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2} !important;
    }
  }

  &:focus {
    outline: none;
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  &[data-com-onepassword-filled],
  &:-webkit-autofill::first-line,
  &:-webkit-autofill {
    background-color: transparent;
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.grey00_7} inset;
    -webkit-text-fill-color: inherit;
    color: ${({ theme }) => theme.colors.black_1};
    font-family: 'CircularXXWeb', sans-serif;
  }
`;
